import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { CloseDialogButton } from '~/components/CloseDialogButton';
import { ResponseError } from '~/domain/ResponseError';

interface IErrorMessageDialog {
  error: ResponseError | Error;
  onClose: () => void;
}

export const ErrorMessageDialog: React.FC<IErrorMessageDialog> = (props) => {
  const { error, onClose } = props;
  const {
    status = '',
    message,
    text,
    stack,
  } = error as Partial<ResponseError>;
  const handleCancel = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    onClose();
  };
  return (
    <Dialog
      open
      onClose={(e, reason) => {
        reason === 'escapeKeyDown' && handleCancel(e as React.MouseEvent);
      }}
      PaperProps={{ sx: { minWidth: 300 } }}
    >
      <DialogTitle>
        <Typography color="error">
          {`${status} ${message}`}
        </Typography>
        <CloseDialogButton onClick={handleCancel} />
      </DialogTitle>
      <DialogContent
        sx={{
          border: '1px solid #eaeaea',
          padding: '15px',
          color: '#333',
          bgcolor: '#f5f5f5',
          lineHeight: '18px',
          fontSize: '13px',
          wordBreak: 'break-all',
          wordWrap: 'break-word',
        }}
      >
        {text || stack}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" variant="contained" onClick={handleCancel}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
